/**
 * Symbolika Shipping Tier Calculator
 */

if (typeof SymbolikaShippingCalculator === 'undefined') {

  class SymbolikaShippingCalculator {

    constructor() {
      this.loadConfig();
      this.init();
    }

    loadConfig() {
      const container = document.getElementById('symbolika-shipping-calculator');

      // Default values (in cents)
      this.TIER_1 = 5000;   // €50.00
      this.TIER_2 = 12000;  // €120.00
      this.COST_HIGH = 800; // €8.00
      this.COST_LOW = 500;  // €5.00
      this.COST_FREE = 0;   // €0.00

      if (container) {
        const tier1 = container.dataset.tier1Threshold;
        const tier2 = container.dataset.tier2Threshold;
        const cost1 = container.dataset.tier1Cost;
        const cost2 = container.dataset.tier2Cost;

        if (tier1 && parseInt(tier1, 10) > 0) this.TIER_1 = parseInt(tier1, 10);
        if (tier2 && parseInt(tier2, 10) > 0) this.TIER_2 = parseInt(tier2, 10);
        if (cost1 && parseInt(cost1, 10) >= 0) this.COST_HIGH = parseInt(cost1, 10);
        if (cost2 && parseInt(cost2, 10) >= 0) this.COST_LOW = parseInt(cost2, 10);
      }
    }

    init() {
      // On initial load, only update if values still show "Calculating..."
      // (shouldn't happen now that Liquid pre-computes, but as a safety net)
      var shipEl = document.getElementById('display-shipping');
      if (shipEl && shipEl.classList.contains('shipping-loading')) {
        this.update();
      }

      const cartForm = document.querySelector('cart-form');
      if (cartForm) {
        cartForm.addEventListener('cart-updated', () => this.updateFromDOM());
      }

      document.addEventListener('cart:refresh', () => this.updateFromDOM());
      document.addEventListener('cart:updated', () => this.updateFromDOM());

      this.observeCartChanges();
    }

    /**
     * Read cart total from the DOM data attribute instead of fetching /cart.js.
     * The Liquid template pre-renders correct values, but the JS calculator
     * still needs to update the progress bar/message after AJAX cart changes
     * since those elements are inside cart-form (replaced separately).
     */
    updateFromDOM() {
      this.loadConfig();
      var subtotalEl = document.getElementById('AjaxCartSubtotal');
      var cartTotal = subtotalEl ? parseInt(subtotalEl.dataset.cartTotal, 10) : 0;
      this.applyCartTotal(cartTotal);
    }

    observeCartChanges() {
      var self = this;
      var cartSubtotal = document.getElementById('AjaxCartSubtotal');
      if (cartSubtotal) {
        var observer = new MutationObserver(function() {
          self.loadConfig();
          self.updateFromDOM();
        });
        observer.observe(cartSubtotal, { childList: true });
      }
    }

    formatEuro(cents) {
      return '€' + (cents / 100).toFixed(2);
    }

    getShipping(total) {
      if (total >= this.TIER_2) return this.COST_FREE;
      if (total >= this.TIER_1) return this.COST_LOW;
      return this.COST_HIGH;
    }

    getMessage(total) {
      if (total >= this.TIER_2) {
        return '<strong class="tier-free">Free shipping unlocked</strong>';
      }
      if (total >= this.TIER_1) {
        const need = this.TIER_2 - total;
        return '<strong class="tier-unlocked">' + this.formatEuro(this.COST_LOW) + ' reduced shipping unlocked</strong><br>Add ' + this.formatEuro(need) + ' more for <strong class="tier-free">free shipping</strong>';
      }
      const need = this.TIER_1 - total;
      return 'Add ' + this.formatEuro(need) + ' more for <strong class="tier-unlocked">' + this.formatEuro(this.COST_LOW) + ' reduced shipping</strong>';
    }

    getProgress(total) {
      if (total >= this.TIER_2) return 100;
      if (total >= this.TIER_1) {
        const range = this.TIER_2 - this.TIER_1;
        const progress = total - this.TIER_1;
        return 40 + (progress / range * 60);
      }
      return (total / this.TIER_1 * 40);
    }

    getShippingLabel(total) {
      if (total >= this.TIER_2) return 'Shipping';
      if (total >= this.TIER_1) return 'Reduced shipping';
      return 'Shipping';
    }

    applyCartTotal(cartTotal) {
      const shipping = this.getShipping(cartTotal);
      const total = cartTotal + shipping;
      const message = this.getMessage(cartTotal);
      const progress = this.getProgress(cartTotal);
      const shippingLabel = this.getShippingLabel(cartTotal);

      const progressFill = document.getElementById('progress-fill');
      if (progressFill) {
        progressFill.style.width = progress + '%';
        if (cartTotal >= this.TIER_2) {
          progressFill.classList.add('free');
        } else {
          progressFill.classList.remove('free');
        }
      }

      this.updateElement('shipping-tier-message', message, true);
      this.updateElement('display-subtotal', this.formatEuro(cartTotal));

      const shippingLabelEl = document.getElementById('shipping-label');
      if (shippingLabelEl) {
        shippingLabelEl.textContent = shippingLabel + ':';
        if (cartTotal >= this.TIER_1 && cartTotal < this.TIER_2) {
          shippingLabelEl.classList.add('reduced');
        } else {
          shippingLabelEl.classList.remove('reduced');
        }
      }

      const shipEl = document.getElementById('display-shipping');
      if (shipEl) {
        shipEl.classList.remove('shipping-loading');
        if (shipping === this.COST_FREE) {
          shipEl.textContent = 'Free';
          shipEl.classList.add('free');
        } else {
          shipEl.textContent = this.formatEuro(shipping);
          shipEl.classList.remove('free');
        }
      }

      const totalEl = document.getElementById('display-total');
      if (totalEl) {
        totalEl.classList.remove('shipping-loading');
        totalEl.textContent = this.formatEuro(total);
      }
    }

    update() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          this.applyCartTotal(cart.total_price);
        })
        .catch(() => {
          // Fallback: read cart total from Liquid-rendered data attribute
          const subtotalEl = document.getElementById('AjaxCartSubtotal');
          const cartTotal = subtotalEl ? parseInt(subtotalEl.dataset.cartTotal, 10) : 0;
          if (cartTotal > 0) {
            this.applyCartTotal(cartTotal);
          }
        });
    }

    updateElement(id, content, isHTML = false) {
      const el = document.getElementById(id);
      if (!el) return;

      if (isHTML) {
        el.innerHTML = content;
      } else {
        el.textContent = content;
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new SymbolikaShippingCalculator();
    });
  } else {
    new SymbolikaShippingCalculator();
  }
}
